import { SnackbarPackProvider } from '@b7hio/core-lib/src';
import { css, Global } from '@emotion/react';
import { LocalizationProvider } from '@mui/lab';
import AdapterLuxon from '@mui/lab/AdapterLuxon';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { FC, ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import theme from './theme/theme';

const queryClient = new QueryClient();

/**
 * Global AppProviders (emotion, nextauth, etc...)
 */
export const AppProviders: FC<{ children?: ReactNode }> = (props) => {
  return (
    <LocalizationProvider dateAdapter={AdapterLuxon} locale="en-GB">
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Global
          styles={css`
            .MuiDataGrid-iconButtonContainer {
              display: none;
            }

            .MuiDataGrid-columnHeader--sorted .MuiDataGrid-iconButtonContainer {
              display: inherit;
            }
          `}
        />
        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
        {/* @ts-expect-error react-query v3 types predate React 18 children prop removal */}
        <QueryClientProvider client={queryClient}>
          <SnackbarPackProvider>{props.children}</SnackbarPackProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </LocalizationProvider>
  );
};
